import React from "react";
import { Chip } from "@mui/material";
import { STATUS_COLORS } from "./_aiOpsTheme";

/**
 * Consistent status pill used across all AI Ops tabs. Maps a status
 * string to one of MUI's semantic colors via `STATUS_COLORS` so
 * "extracted", "answered", "confirmed" all read the same green;
 * "error" / "handler_error" / "narrator_error" all read the same red.
 */
export default function StatusChip({ status, ...rest }) {
  if (!status) return <Chip size="small" label="—" {...rest} />;
  const color = STATUS_COLORS[status] || "default";
  return (
    <Chip
      size="small"
      label={status}
      color={color}
      sx={{
        fontFamily: "monospace",
        fontSize: 10,
        fontWeight: 700,
        height: 22,
      }}
      {...rest}
    />
  );
}
